export default __webpack_public_path__ + "static/media/test_product_card.c7a2ad68.png";